import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";

const AboutPage = () => {
  return (
    <div className="padding">
      <div className="about">
        <Helmet>
          <title>about us - dubu</title>
          <meta
            name="keywords"
            content="about, kpop, dubu, database, kpop credits"
          />
          <meta
            name="description"
            content="About page for dubu: a database of your favorite KPOP idols, albums, songs, and credits."
          />
        </Helmet>
        <div className="about-photo">
          <img
            className="about-photo-img"
            loading="lazy"
            alt="learn about dubu, website for kpop credits, artists, and song information"
            src="/iuAbout.jpeg"
          />
        </div>
        <div className="text-section">
          <h3>👋 about us</h3>
          <p>
            Welcome to dubu, your go-to source for information about K-Pop
            songs, albums, and artists. Our mission is to make K-Pop more accessible
            through a comprehensive English-language database, while highlighting the talented artists,
            producers, and lyricists behind the music. You can also write reviews, create playlists, and
            share your favorites with the community. Dive into your favorite
            artist&apos;s discography or discover someone new!
          </p>
        </div>
        <div className="text-section">
          <h3>⚙️ how it works</h3>
          <p>There are a few ways to explore artists, songs, and albums:</p>
          <p>
            <ul className="a-list">
              Discover the latest releases on the home page.
            </ul>{" "}
            <ul className="a-list">
              Search for your favorite artists, albums, and songs.
            </ul>{" "}
            <ul className="a-list">Browse categorized lists of idols.</ul>
            <ul className="a-list">Create your own playlists and song reviews.</ul>
            <ul className="a-list">
              Click on the dubu icon on the top left for a surprise!
            </ul>
          </p>
          <br></br>
          <p>
            Each artist page offers insights on associated groups, members, releases, and music production credits.
            Any lyricist, composer, or arranger with idol credits also has a dedicated page to showcase their work.
          </p>
        </div>
        <div className="text-section">
          <h3>📝 notes</h3>
          <p>
            We're in beta, so some information may be incomplete or imperfect.
            Please report any mistranslations using the{" "}
            <Link to="/feedback">feedback form</Link>.
          </p>
          <p>Thank you for using dubu - we appreciate your feedback and support!</p>
        </div>
      </div>
    </div>
  );
};

export default AboutPage;
